import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useCafAnalysisComponentDetailListV5 } from '../../../../../modules/apis/webview/caf'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { ICON_CHEVRON_RIGHT_GRAY } from '../../../../../modules/svg/svg'
import urls from '../../../../../modules/urls'
import ThickDivider from '../../../../webview/caf/common/ThickDivider'
import PronunciationIntroSection from '../../analysis/pronunciation/PronunciationIntroSection'
import { pronunciationTabListMap } from '../../analysis/pronunciation/PronunciationTabsSection'
import useMetricSidePopup from '../popup/useMetricSidePopup'

interface Props {
  componentId: number
}
const CAFOverviewPronunciation = ({ componentId }: Props) => {
  const router = useAppRouter()
  useMetricSidePopup('Pronunciation')
  const { t, locale } = useTranslation()
  const { lessonId, tab } = router.query
  const { data } = useCafAnalysisComponentDetailListV5(componentId)
  const [selectedMetric, setSelectedMetric] = useState<{ title: string[]; value: string; index: number }>({
    title: [],
    value: null,
    index: -1,
  })

  useEffect(() => {
    router.push(urls.student.newPortal.lessons.reviewDetail.asCafMetric(lessonId, 4, componentId, selectedMetric.value))
  }, [selectedMetric])

  if (!data?.metrics) return null
  return (
    <div className="w-screen px-[16px] sm:w-[424px] sm:px-0">
      <div className="keep-all min-h-screen break-words bg-white pt-[16px] pb-[40px] text-gray-700">
        <div className="mb-[16px] flex flex-row items-center justify-start text-[20px] font-bold text-black">
          {t(n_caf.highlight_list.pronunciation1)}
          <div className="ml-[8px] rounded-[4px] bg-red-50 px-[6px] py-[2px] text-[10px] font-bold text-red-400">
            Beta
          </div>
        </div>
        <PronunciationIntroSection componentId={componentId} />
        <ThickDivider />
        <div className="mb-[16px] mt-[20px] text-[20px] font-bold text-black">{t(n_caf.pronunciation.metric)}</div>
        {data?.metrics?.map((metric, i) => (
          <ArrowBox
            key={`metric_${pronunciationTabListMap[metric.metric_tag].value}`}
            title={t(pronunciationTabListMap[metric.metric_tag].title)}
            onClick={
              selectedMetric.value === pronunciationTabListMap[metric.metric_tag].value
                ? () => setSelectedMetric({ title: [], value: null, index: -1 })
                : () => setSelectedMetric({ ...pronunciationTabListMap[metric.metric_tag], index: i })
            }
            active={selectedMetric.value === pronunciationTabListMap[metric.metric_tag].value}
            rightText={metric.value}
          />
        ))}
      </div>
    </div>
  )
}
interface ArrowBoxProps {
  title: string
  onClick: any
  active: boolean
  rightText?: string | number
}
const ArrowBox = ({ title, onClick, active, rightText }: ArrowBoxProps) => {
  return (
    <div
      className={classNames(
        `mb-[8px] flex min-h-[72px] cursor-pointer items-center rounded-[6px] px-[16px] py-[12px] shadow-sm`,
        active ? 'border-[1.5px] border-purple-500 bg-purple-50' : 'border-[1px] border-gray-200 bg-white'
      )}
      onClick={onClick}
    >
      <div className="flex flex-1 items-center justify-between">
        <div>
          <h3 className={classNames('text-[16px]', active ? 'font-bold text-purple-500' : 'font-normal text-black')}>
            {title}
          </h3>
        </div>
        <div className="flex items-center">
          {!!String(rightText) && <span className="text-h5 mr-[16px] text-gray-500 sm:text-[16px]">{rightText}</span>}
          <img src={ICON_CHEVRON_RIGHT_GRAY} alt="chevron" />
        </div>
      </div>
    </div>
  )
}

export default CAFOverviewPronunciation
